<div class="custom-select">
    <div
        data-cy="channel-filter-dropdown"
        class="select-box"
        [class.focus]="dropdownOpen"
        (click)="onDropdownClick($event)"
    >
        <div class="selected-container">
            <h6
                data-cy="channel-filter-subtitle"
                class="selected-sub-title"
                [class.focus]="dropdownOpen"
                [class.show]="dropdownOpen || selectedItemName"
            >
                {{ noneSelectName }}
            </h6>
            <div
                data-cy="channel-filter-selected-items"
                class="selected-option"
                [class.active]="selectedItemName"
            >
                {{ selectedItemName || (dropdownOpen ? "" : noneSelectName) }}
            </div>
        </div>
        <div class="arrow-wrapper">
            <mat-icon
                class="arrow"
                [class.focus]="dropdownOpen"
                svgIcon="dropdown-arrow"
            />
        </div>
    </div>
    <ul class="items-list" [class.show]="dropdownOpen">
        <li
            data-cy="channel-filter-dropdown-item"
            class="item"
            *ngFor="let item of items; index as i"
            (click)="onItemClick($event, i)"
        >
            <mat-checkbox
                data-cy="channel-filter-dropdown-checkbox"
                class="checkbox"
                [checked]="item.selected"
            />
            <span>{{ item.name }}</span>
        </li>
    </ul>
</div>
